var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-default left-details"},[_c('figure',[_c('router-link',{attrs:{"to":`${_vm.product.slug}`}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.product.image),expression:"product.image"}],key:`related-large-${_vm.product.id}`,attrs:{"alt":"large-picture"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }